/* ux-carro.js — unionx.cl · carro «dirección A» (como Lippi) · 01/10/2026, OK de Martin.
 *
 * 1) «Completa tu compra». Lo que se sugiere tiene que conversar con lo que hay en el carro
 *    (Martin: «que los recomendados conversen»):
 *      a. primero los complementos CURADOS de cada producto del carro (`custom.complementos_handles`,
 *         los mismos del «Comprados juntos» de la ficha: se usan juntos, otra categoría, más baratos);
 *      b. si faltan, los relacionados de Shopify de la MISMA marca y de OTRO tipo (complemento, no
 *         sustituto: con un parlante no se sugiere otro parlante), y que cuesten hasta lo que vale el
 *         producto o lo que falta para el despacho gratis.
 *    Siempre con stock y nunca algo que ya está en el carro. Si no hay nada que converse, no se
 *    muestra nada (mejor vacío que una silla de oficina al lado de un parlante, como pasaba).
 *    Escritorio (≥990 px): panel a la izquierda del cajón. Celular y página /cart: dentro del carro.
 *
 * 2) Boleta/Factura en una ventana aparte (Martin: «que esté en otro lado, no en el carro»).
 *    En el carro queda una línea; los campos siguen siendo los de `factura-selector` y la captura la
 *    sigue haciendo `ux-factura-selector.js` (billing_* → n8n → Odoo). Acá solo se abre/cierra la
 *    ventana, se guarda todo de una al tocar «Listo» y se reabre si el checkout queda bloqueado.
 *
 * Datos: el tema pinta `<script type="application/json" data-uxcd-datos>` (snippet ux-carro-datos).
 * Fuente: areas/paginas-propias/_comun/carro-2026-10/unionx/assets/ux-carro.js
 */
(function () {
  'use strict';
  if (window.__uxCarro) return;
  window.__uxCarro = 1;

  var MAX = 4;
  var fmt = function (c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (x) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[x]; }); };
  var COLORES = { negro: '#1b1b1b', black: '#1b1b1b', blanco: '#ffffff', white: '#ffffff', gris: '#8a8f98', 'gris oscuro': '#4b4f56', grafito: '#4b4f56', plata: '#c9ccd1', azul: '#1f4fa0', 'azul marino': '#1d2a4d', 'azul oscuro': '#1d2a4d', 'azul claro': '#8fb8e8', 'verde militar': '#4b5a3a', 'gris claro': '#c9ccd1', 'rojo vino': '#6d1f2b', 'negro mate': '#1b1b1b', marino: '#1d2a4d', celeste: '#8fd0de', rojo: '#c8302c', burdeo: '#6d1f2b', rosado: '#f2b5c3', rosa: '#f2b5c3', verde: '#3f7d4e', 'verde oliva': '#6b7445', oliva: '#6b7445', amarillo: '#f2c230', naranjo: '#e8772e', naranja: '#e8772e', morado: '#6d4b9a', lila: '#b9a3d6', beige: '#d9c7a7', cafe: '#6f4e37', 'café': '#6f4e37', crema: '#efe6d2', arena: '#d6c3a0', turquesa: '#2bb3b1', dorado: '#c9a54c', cobre: '#b87333' };

  /* ---------------- datos ---------------- */
  var cacheProd = {}, cacheRel = {};
  function prod(h) {
    if (!cacheProd[h]) cacheProd[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cacheProd[h];
  }
  function relacionados(id) {
    if (!cacheRel[id]) cacheRel[id] = fetch('/recommendations/products.json?product_id=' + id + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return j.products || []; })
      .catch(function () { return []; });
    return cacheRel[id];
  }
  function leerDatos() {
    var el = document.querySelector('[data-uxcd-datos]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function coleccion() {
    var h = window.SPX_COMPLETA && window.SPX_COMPLETA.coleccion;
    if (!h) return Promise.resolve([]);
    if (!cacheRel['col:' + h]) cacheRel['col:' + h] = fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=40', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j.products || []).map(function (p) { return { handle: p.handle, vendor: p.vendor, type: p.product_type, available: (p.variants || []).some(function (v) { return v.available; }), price: Math.round(parseFloat((p.variants[0] || {}).price || 0) * 100) }; }); })
      .catch(function () { return []; });
    return cacheRel['col:' + h];
  }

  // Siempre 4 (Martin 01/10: «siempre que recomiende 4»). Se llena por escalones, del que más conversa
  // con el carro al que menos, y nunca se repite ni se ofrece algo que ya está en el carro:
  //   1. complementos curados de lo que hay en el carro (los del «Comprados juntos» de la ficha)
  //   2. relacionados de Shopify de cada producto del carro: misma marca, otro tipo, precio hasta lo que
  //      vale el producto o lo que falta para el despacho gratis
  //   3. relacionados de otro tipo, sin tope de precio
  //   4. cualquier relacionado
  //   5. la colección de destacados de la tienda (SPX_COMPLETA.coleccion)
  function elegir(d) {
    var enCarro = {}, tiposCarro = {};
    d.items.forEach(function (i) { enCarro[i.h] = 1; tiposCarro[(i.t || '').toLowerCase()] = 1; });
    var elegidos = [], ya = {};
    var sumar = function (h) { if (h && !enCarro[h] && !ya[h] && elegidos.length < MAX * 3) { ya[h] = 1; elegidos.push(h); } };
    d.items.forEach(function (i) { (i.c || []).forEach(sumar); });
    var bases = d.items.slice(0, 3);
    return Promise.all(bases.map(function (i) { return relacionados(i.p); })).then(function (rels) {
      var tipo = function (p) { return (p.type || '').toLowerCase(); };
      var escalones = [
        function (p, i) { return (p.vendor || '').toLowerCase() === (i.v || '').toLowerCase() && !tiposCarro[tipo(p)] && p.price <= Math.max(i.pr, d.falta || 0); },
        function (p) { return !tiposCarro[tipo(p)]; },
        function () { return true; }
      ];
      escalones.forEach(function (ok) {
        rels.forEach(function (lista, k) { lista.forEach(function (p) { if (p.available && ok(p, bases[k])) sumar(p.handle); }); });
      });
      return elegidos.length >= MAX ? null : coleccion();
    }).then(function (col) {
      (col || []).forEach(function (p) { if (p.available) sumar(p.handle); });
      return Promise.all(elegidos.map(prod));
    }).then(function (lista) {
      return lista.filter(function (p) { return p && p.available; }).slice(0, MAX);
    });
  }

  /* ---------------- tarjetas ---------------- */
  function img(src, w) {
    if (!src) return '';
    src = src.replace(/^\/\//, 'https://');
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function opcionColor(p) {
    var names = (p.options || []).map(function (o) { return (o && o.name) || o; });
    if (names.length !== 1) return -1;
    return /color|colour/i.test(names[0]) ? 0 : -1;
  }
  function tarjeta(p, falta) {
    var vs = p.variants.filter(function (v) { return v.available; });
    var v0 = vs[0];
    var ic = opcionColor(p);
    var simple = p.variants.length === 1 || ic === 0;
    var sw = '';
    if (ic === 0 && vs.length > 1) {
      sw = '<span class="uxcd-sw" role="radiogroup" aria-label="Color">' + vs.slice(0, 6).map(function (v, k) {
        var nom = v.option1 || '', hex = COLORES[nom.toLowerCase().trim()];
        var vimg = v.featured_image ? img(v.featured_image.src, 240) : '';
        return '<button type="button" class="uxcd-sw__c' + (k ? '' : ' is-on') + (hex ? '' : ' uxcd-sw__c--txt') + '" role="radio" aria-checked="' + (k ? 'false' : 'true') + '" title="' + esc(nom) + '" aria-label="' + esc(nom) + '" data-uxcd-v="' + v.id + '" data-uxcd-img="' + esc(vimg) + '"' + (hex ? ' style="--c:' + hex + '"' : '') + '>' + (hex ? '' : esc(nom)) + '</button>';
      }).join('') + '</span>';
    }
    var foto = (v0 && v0.featured_image && v0.featured_image.src) || p.featured_image;
    var precio = v0 ? v0.price : p.price, antes = v0 ? v0.compare_at_price : p.compare_at_price;
    var url = '/products/' + p.handle;
    return '<div class="uxcd-tj" data-uxcd-h="' + esc(p.handle) + '">' +
      '<a class="uxcd-tj__img" href="' + url + '" tabindex="-1"><img src="' + esc(img(foto, 240)) + '" alt="' + esc(p.title) + '" width="120" height="120"></a>' +
      '<div class="uxcd-tj__info"><span class="uxcd-tj__mar">' + esc(p.vendor) + '</span>' +
      '<a class="uxcd-tj__nom" href="' + url + '">' + esc(p.title) + '</a>' +
      '<span class="uxcd-tj__p">' + fmt(precio) + (antes > precio ? ' <s>' + fmt(antes) + '</s>' : '') + '</span></div>' +
      (falta > 0 && precio >= falta ? '<span class="uxcd-tj__gratis">Con este tienes despacho gratis</span>' : '') +
      '<div class="uxcd-tj__pie">' + sw +
      (simple && v0 ? '<button type="button" class="uxcd-add" data-uxcd-add="' + v0.id + '">Agregar</button>'
        : '<a class="uxcd-add" href="' + url + '">Elegir</a>') +
      '</div></div>';
  }

  /* ---------------- pintar ---------------- */
  var firma = '', ultimo = [];
  function contenedores() {
    var dlg = document.querySelector('#cart-drawer .theme-drawer__dialog');
    var lado = null;
    if (dlg) {
      lado = dlg.querySelector(':scope > .uxcd-lado');
      if (!lado) {
        lado = document.createElement('aside');
        lado.className = 'uxcd-lado';
        lado.setAttribute('aria-label', 'Completa tu compra');
        dlg.insertBefore(lado, dlg.firstChild);
      }
    }
    // Tema Icon (Simplit, 05/10/2026): su cajón `#slideout-ajax-cart` recorta lo que sobresale (overflow
    // hidden), así que el panel no puede ir dentro: va fijo en el body, pegado a su izquierda, y el CSS lo
    // muestra solo con el cajón abierto (`.slideout--active`) y en escritorio.
    var icon = !dlg && document.getElementById('slideout-ajax-cart');
    if (icon) {
      lado = document.querySelector('body > .uxcd-lado--icon');
      if (!lado) {
        lado = document.createElement('aside');
        lado.className = 'uxcd-lado uxcd-lado--icon';
        lado.setAttribute('aria-label', 'Completa tu compra');
        document.body.appendChild(lado);
      }
      if (icon.offsetWidth) document.documentElement.style.setProperty('--uxcd-icon-w', icon.offsetWidth + 'px');
    }
    return { dlg: dlg, icon: icon, lado: lado, dentro: [].slice.call(document.querySelectorAll('[data-uxcd-dentro]')) };
  }
  // 🪤 Tema Icon (Simplit): su ajaxCart repinta las líneas en el navegador y el bloque de datos de Liquid
  // queda viejo (seguía sugiriendo lo recién agregado). Ahí se lee el carro real (/cart.js, caché 2 s) y del
  // bloque de datos solo se toman los complementos curados.
  var cacheCart = null;
  function obtener(d) {
    if (!d || !document.getElementById('cart-config')) return Promise.resolve(d);
    var ahora = Date.now();
    var pedir = cacheCart && ahora - cacheCart.t < 2000 ? Promise.resolve(cacheCart.c)
      : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cacheCart = { t: ahora, c: c }; return c; });
    return pedir.then(function (c) {
      var cur = {}; d.items.forEach(function (i) { cur[i.h] = i.c; });
      return { falta: Math.max(0, (d.u || 0) - c.total_price), u: d.u, items: c.items.map(function (i) { return { h: i.handle, p: i.product_id, t: i.product_type, v: i.vendor, pr: i.final_price, c: cur[i.handle] || null }; }) };
    }).catch(function () { return d; });
  }
  function pintar() {
    obtener(leerDatos()).then(pintarCon);
  }
  function pintarCon(d) {
    var c = contenedores();
    if (!d || !d.items.length) {
      if (c.dlg) c.dlg.classList.remove('uxcd-ancho');
      if (c.icon && c.lado) c.lado.classList.remove('uxcd-on');
      c.dentro.forEach(function (el) { el.innerHTML = ''; });
      return;
    }
    var f = JSON.stringify([d.items.map(function (i) { return i.h; }), d.falta]);
    var aplicar = function (lista) {
      ultimo = lista;
      var tit = '<p class="uxcd-tit">Completa tu compra</p><p class="uxcd-baj">Van bien con lo que llevas</p>';
      var html = lista.map(function (p) { return tarjeta(p, d.falta); }).join('');
      // Solo se reescribe si cambió: el observer salta con cualquier cambio de la página (la cuenta
      // regresiva del Cyber late cada segundo) y reescribir recargaba las fotos en cada latido.
      var poner = function (el, contenido) { if (el.getAttribute('data-uxcd-f') === f && (el.firstElementChild || !contenido)) return; /* 🪤 el morph de Horizon puede vaciarlo */ el.setAttribute('data-uxcd-f', f); el.innerHTML = contenido; };
      if (c.lado) poner(c.lado, lista.length ? tit + '<div class="uxcd-lista">' + html + '</div>' : '');
      if (c.dlg) c.dlg.classList.toggle('uxcd-ancho', !!lista.length);
      if (c.icon && c.lado) c.lado.classList.toggle('uxcd-on', !!lista.length);
      c.dentro.forEach(function (el) { poner(el, lista.length ? '<p class="uxcd-tit">Completa tu compra</p><div class="uxcd-fila">' + html + '</div>' : ''); });
    };
    if (f === firma) { aplicar(ultimo); return; }
    firma = f;
    elegir(d).then(function (lista) { if (f === firma) aplicar(lista); }).catch(function () {});
  }

  /* ---------------- agregar ---------------- */
  function eventos(cb) {
    if (window.__lhxEventosShopify) return cb(window.__lhxEventosShopify);
    document.addEventListener('lhx:eventos-shopify', function () { cb(window.__lhxEventosShopify); }, { once: true });
    if (!document.getElementById('lhx-eventos-shopify')) {
      var s = document.createElement('script');
      s.type = 'module';
      s.id = 'lhx-eventos-shopify';
      s.textContent = "import * as m from '@shopify/events'; window.__lhxEventosShopify = m; document.dispatchEvent(new Event('lhx:eventos-shopify'));";
      document.head.appendChild(s);
    }
  }
  function refrescar(items) {
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    // Tema Icon (Simplit): el cajón se repinta con su propio ajaxCart (mismo camino que spx-completa-envio).
    var cfgIcon = document.getElementById('cart-config'), th = window.Shopify && Shopify.theme;
    if (cfgIcon && th && th.cart && th.ajaxCart) {
      var cfg = {}; try { cfg = JSON.parse(cfgIcon.innerHTML || '{}'); } catch (e) {}
      th.cart.getCart().then(function (c) { th.ajaxCart.updateView(cfg, c); });
      return;
    }
    eventos(function (m) {
      if (!m || !m.CartLinesUpdateEvent) { location.reload(); return; }
      var dd = m.CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'add', context: 'product',
        lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }), promise: dd.promise }));
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (cart) { var a = m.CartLinesUpdateEvent.createCartFromAjaxResponse; dd.resolve({ cart: a ? a(cart) : null, detail: { itemCount: cart.item_count } }); })
        .catch(function (e) { dd.reject(e); });
    });
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.uxcd-sw__c');
    if (sw) {
      var tj = sw.closest('.uxcd-tj');
      [].forEach.call(tj.querySelectorAll('.uxcd-sw__c'), function (b) { b.classList.toggle('is-on', b === sw); b.setAttribute('aria-checked', b === sw ? 'true' : 'false'); });
      var add = tj.querySelector('[data-uxcd-add]');
      if (add) add.setAttribute('data-uxcd-add', sw.getAttribute('data-uxcd-v'));
      var im = sw.getAttribute('data-uxcd-img');
      if (im) tj.querySelector('.uxcd-tj__img img').src = im;
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-uxcd-add]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    var items = [{ id: Number(btn.getAttribute('data-uxcd-add')), quantity: 1 }];
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'Agregando…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { btn.textContent = 'Agregado ✓'; cacheCart = null; refrescar(items); setTimeout(pintar, 900); })
      .catch(function () { btn.removeAttribute('aria-disabled'); btn.textContent = 'Agregar'; });
  });

  /* ---------------- Boleta/Factura en ventana aparte ---------------- */
  var REQ = ['rut', 'rzn_social', 'giro', 'comuna', 'direccion'];
  function dv(b) { var s = 0, m = 2; for (var i = b.length - 1; i >= 0; i--) { s += +b[i] * m; m = m === 7 ? 2 : m + 1; } var r = 11 - (s % 11); return r === 11 ? '0' : r === 10 ? 'K' : String(r); }
  function rutOk(v) { var l = (v || '').replace(/[.\-\s]/g, '').toUpperCase(), b = l.slice(0, -1); return /^\d+$/.test(b) && b.length >= 7 && dv(b) === l.slice(-1); }
  function val(root, k) { var el = root.querySelector('[data-ux="' + k + '"]'); return el ? el.value.trim() : ''; }
  function resumen(caja) {
    var root = caja.querySelector('.ux-doc'), out = caja.querySelector('[data-uxfv-resumen]');
    if (!root || !out) return;
    if (val(root, 'documento') === 'factura' && val(root, 'rzn_social')) out.innerHTML = 'Factura para <b>' + esc(val(root, 'rzn_social')) + '</b> · <u>Cambiar</u>';
    else out.innerHTML = '¿Necesitas factura? <u>Ingresa los datos de tu empresa</u>';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-uxfv-abrir],[data-uxfv-cerrar],[data-uxfv-listo]');
    if (!t) return;
    var caja = t.closest('[data-uxfv]'), dlg = caja && caja.querySelector('[data-uxfv-dlg]');
    if (!dlg) return;
    e.preventDefault();
    if (t.hasAttribute('data-uxfv-abrir')) { if (!dlg.open) dlg.showModal(); return; }
    if (t.hasAttribute('data-uxfv-cerrar')) { dlg.close(); resumen(caja); return; }
    var root = dlg.querySelector('.ux-doc'), msg = root.querySelector('[data-ux="rut-msg"]');
    var doc = val(root, 'documento') || 'boleta';
    var attrs = { billing_documento: doc };
    if (doc === 'factura') {
      var falta = REQ.filter(function (k) { return !val(root, k); });
      if (falta.length || !rutOk(val(root, 'rut'))) {
        if (msg) { msg.textContent = falta.length ? 'Completa todos los datos de facturación' : 'RUT inválido: revisa el dígito verificador'; msg.className = 'ux-doc__msg ux-doc__msg--err'; }
        return;
      }
      REQ.forEach(function (k) { attrs[k === 'rzn_social' ? 'billing_rzn_social' : 'billing_' + k] = val(root, k); });
    }
    t.setAttribute('aria-disabled', 'true');
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .catch(function () {})
      .then(function () { t.removeAttribute('aria-disabled'); dlg.close(); resumen(caja); });
  });
  // Si el checkout queda bloqueado (factura incompleta), ux-factura-selector escribe el error en
  // la ventana cerrada: se abre para que el cliente lo vea.
  function vigilarBloqueo() {
    [].forEach.call(document.querySelectorAll('[data-uxfv-dlg]'), function (dlg) {
      var m = dlg.querySelector('[data-ux="rut-msg"]');
      if (m && !dlg.open && /ux-doc__msg--err/.test(m.className) && /Completa|inv/i.test(m.textContent)) {
        if (dlg.closest('dialog[open]') || dlg.closest('main')) dlg.showModal();
      }
    });
  }
  // 🪤 ux-factura-selector corta el click del checkout con stopImmediatePropagation: por eso se marca
  // la intención en pointerdown/keydown (que nadie corta) y el error se detecta con el observer.
  var ultimoPagar = 0;
  ['pointerdown', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (ev === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      if (e.target.closest && e.target.closest('[name="checkout"]')) ultimoPagar = Date.now();
    }, true);
  });

  /* ---------------- ciclo ---------------- */
  var t = null;
  function programar() { clearTimeout(t); t = setTimeout(function () { pintar(); [].forEach.call(document.querySelectorAll('[data-uxfv]'), resumen); }, 80); }
  function iniciar() {
    pintar();
    if (window.MutationObserver) new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var n = ms[i].target;
        if (n.closest && n.closest('[data-uxfv-dlg]')) { if (Date.now() - ultimoPagar < 2000) setTimeout(vigilarBloqueo, 30); continue; }
        if (n.closest && (n.closest('.uxcd-lado') || n.closest('[data-uxcd-dentro]'))) continue;
        programar(); return;
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
